<template>
<el-dialog :title="viewFlag === 'view' ? '查看' : !dataForm.id ? '新增' : '修改'" :close-on-click-modal="false" width="80%" :visible.sync="viewData.visible">
    <el-form :model="dataForm" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" class="org-dialog-form" size="small">
        <el-tabs v-model="activeName">
            <el-tab-pane :key="2" name="first" label="基础信息" class="tab_style">
                <div class="des_box">
                    <el-descriptions class="margin-top" :column="2" size="small" border style="margin-bottom: 15px;">
                        <el-descriptions-item label="订单编码" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="orderCode" style="margin-bottom: 0;">
                                <span v-if="viewFlag === 'view'">{{dataForm.orderCode}}</span>
                                <el-input v-else size="small" v-model="dataForm.orderCode" placeholder="订单编码" clearable></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="订单状态" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="orderStatus" style="margin-bottom: 0;">
                                <span v-if="viewFlag === 'view'">{{getProductionOrderStatusByValue(dataForm.orderStatus)}}</span>
                                <el-select v-else v-model="dataForm.orderStatus" placeholder="请选择" clearable style="width: 200px;">
                                    <el-option v-for="item in PRODUCTION_ORDER_STATUS" :key="item.value" :label="item.label" :value="item.value" />
                                </el-select>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="供应商编码" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="supplierCode" style="margin-bottom: 0;">
                                <span v-if="viewFlag === 'view'">{{dataForm.supplierCode}}</span>
                                <el-input v-else size="small" v-model="dataForm.supplierCode" placeholder="供应商编码" clearable></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="供应商名称" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="supplierName" style="margin-bottom: 0;">
                                <span v-if="viewFlag === 'view'">{{dataForm.supplierName}}</span>
                                <el-input v-else size="small" v-model="dataForm.supplierName" placeholder="供应商名称" clearable></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="采购日期" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="bedat" style="margin-bottom: 0;">
                                <span v-if="viewFlag === 'view'">{{dataForm.bedat}}</span>
                                <el-date-picker v-else v-model="dataForm.bedat" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择采购日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="订单类型" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="orderType" style="margin-bottom: 0;">
                                <span v-if="viewFlag === 'view'">{{dataForm.orderType}}</span>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="订单类型" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="orderType" style="margin-bottom: 0;">
                                <span v-if="viewFlag === 'view'">{{getSopOrderTypeByValue(dataForm.orderType)}}</span>
                                <el-select v-else v-model="dataForm.orderType" placeholder="请选择" clearable style="width: 200px;">
                                    <el-option v-for="item in SOP_ORDER_TYPE" :key="item.value" :label="item.label" :value="item.value" />
                                </el-select>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="采购组织" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="ekorg" style="margin-bottom: 0;">
                                <span v-if="viewFlag === 'view'">{{dataForm.ekorg}}</span>
                                <el-input v-else size="small" v-model="dataForm.ekorg" placeholder="采购组织" clearable></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="采购组织名称" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="ekotx" style="margin-bottom: 0;">
                                <span v-if="viewFlag === 'view'">{{dataForm.ekotx}}</span>
                                <el-input v-else size="small" v-model="dataForm.ekotx" placeholder="采购组织名称" clearable></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="采购组" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="ekgrp" style="margin-bottom: 0;">
                                <span v-if="viewFlag === 'view'">{{dataForm.ekgrp}}</span>
                                <el-input v-else size="small" v-model="dataForm.ekgrp" placeholder="采购组" clearable></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="采购组描述" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="eknam" style="margin-bottom: 0;">
                                <span v-if="viewFlag === 'view'">{{dataForm.eknam}}</span>
                                <el-input v-else size="small" v-model="dataForm.eknam" placeholder="采购组的描述" clearable></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="公司代码" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="bukrs" style="margin-bottom: 0;">
                                <span v-if="viewFlag === 'view'">{{dataForm.bukrs}}</span>
                                <el-input v-else size="small" v-model="dataForm.bukrs" placeholder="公司代码" clearable></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="公司名称" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="butxt" style="margin-bottom: 0;">
                                <span v-if="viewFlag === 'view'">{{dataForm.butxt}}</span>
                                <el-input v-else size="small" v-model="dataForm.butxt" placeholder="公司名称" clearable></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="文本描述" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="txz02" style="margin-bottom: 0;">
                                <span v-if="viewFlag === 'view'">{{dataForm.txz02}}</span>
                                <el-input v-else type="textarea" v-model="dataForm.txz02" :rows="3" placeholder="备注"></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                    </el-descriptions>
                </div>
            </el-tab-pane>
            <el-tab-pane :key="1" name="second" label="明细信息" class="tab_style">
                <el-form :inline="true" :model="searchForm" @keyup.enter.native="queryHandle()" size="small">
                    <el-form-item label="物料号:">
                        <el-input size="small" v-model="searchForm.partCode" placeholder="物料号" clearable @blur="queryHandle"></el-input>
                    </el-form-item>
                    <el-form-item label="交货完成:">
                        <el-select size="small" v-model="dataForm.orderComplete" placeholder="请选择状态" clearable @change="queryHandle">
                            <el-option v-for="item in ORDER_COMPLETE" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="fr">
                        <el-button size="small" @click="queryHandle()" icon="el-icon-search">
                            查询
                        </el-button>
                    </el-form-item>
                </el-form>
                <el-row :gutter="10">
                    <el-col :span="24">
                        <el-table :data="orderPartList" row-key="id" size="small" border style="width: 100%" :default-expand-all="false" :header-cell-style="{ background: '#f5f5f5' }">
                            <el-table-column type="index" width="50" label="序号">
                                <template slot-scope="scope">
                                    {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="ebelp" header-align="center" align="center" label="订单行项" width="100">
                            </el-table-column>
                            <el-table-column prop="pstyp" header-align="center" align="center" label="项目类别">
                                <template slot-scope="scope">
                                    {{ PSTYP_TYPE(scope.row.pstyp) }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="partCode" header-align="center" align="left" label="物料号" width="350">
                            </el-table-column>
                            <el-table-column prop="partName" header-align="center" align="left" label="物料名称" width="350">
                            </el-table-column>
                            <el-table-column prop="count" header-align="center" align="right" label="订单数量">
                            </el-table-column>
                            <el-table-column prop="unit" header-align="center" align="center" label="订单单位">
                                <template slot-scope="scope">
                                    <span>{{getUnitName(scope.row.unit)}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="baseQuan" header-align="center" align="right" label="基本单位数量" width="100">
                            </el-table-column>
                            <el-table-column prop="baseMeins" header-align="center" align="center" label="基本单位">
                            </el-table-column>
                            <el-table-column width="120" prop="lfimg" header-align="center" align="right" label="历史交货数量">
                                <template slot-scope="scope">
                                    <span>{{getLfimg(scope.row.lfimg)}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="eidnt" header-align="center" align="right" label="交货日期">
                            </el-table-column>
                            <el-table-column prop="elikz" header-align="center" align="center" label="交货完成">
                                <template slot-scope="scope">
                                    <span>{{getElikz(scope.row.elikz)}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="orderConfirm" header-align="center" align="center" label="订单确认">
                                <template slot-scope="scope">
                                    <span>{{getOrderConfirm(scope.row.orderConfirm)}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="deleteFlag" header-align="center" align="center" label="删除标记">
                                <template slot-scope="scope">
                                    <span>{{getDeleteFlag(scope.row.deleteFlag)}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="street" header-align="center" align="left" label="收货地址" width="300">
                            </el-table-column>
                            <el-table-column prop="werks" header-align="center" align="center" label="工厂">
                            </el-table-column>
                            <el-table-column prop="name2" header-align="center" align="center" label="工厂名称" width="300">
                            </el-table-column>
                            <el-table-column prop="lgort" header-align="center" align="center" label="库存地点">
                            </el-table-column>
                            <el-table-column prop="lgobe" header-align="center" align="center" label="地点名称" width="200">
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
                <!-- 分页 -->
                <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper" class="mb15">
                </el-pagination>
            </el-tab-pane>
            <!-- <el-tab-pane :key="4" label="附件文件"> -->
            <!-- TODO:上传下载 产看 需求文档 -->
            <!-- <FilesUpDown ref="FilesUpDown" :bizId="dataForm.id" :bizType="FILE_BIZ_TYPE"></FilesUpDown>
            </el-tab-pane> -->
        </el-tabs>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewData.visible = false">
            取消
        </el-button>
        <!-- <el-button v-if="this.dataForm.orderStatus !== '1' && this.dataForm.orderStatus !== '2' && this.dataForm.orderStatus !== '3'" size="small" type="danger" @click="deleteHandle()">
                订单关闭
            </el-button> -->
        <!-- <el-button v-if="this.dataForm.orderStatus !== '1' && this.dataForm.orderStatus !== '2' && this.dataForm.orderStatus !== '3'" size="small" type="success" @click="confirm()">
                确认订单
            </el-button> -->
        <!-- <el-button size="small" type="primary">
                同步订单
            </el-button> -->
        <!-- <el-button size="small" type="warning">
                生成询价单
            </el-button> -->
        <!-- <el-button size="small" type="primary">
                生成订单管理
            </el-button> -->
    </span>
    <common-user-dialog ref="commonUserDialog"></common-user-dialog>
    <!-- 弹窗, 新增 / 修改 零件-->
    <!-- <add-or-update-order-appartment v-if="addOrUpdateOrderAppartmentVisible" ref="addOrUpdateOrderAppartment" @refreshOrderAppartmentDataList="getOrderTblPartList"></add-or-update-order-appartment> -->
</el-dialog>
</template>

<script>
// import AddOrUpdateOrderAppartment from "./order-appart-add-or-update";
import {
    getOrderOtsById,
    createOrder,
    editOrder,
    getOrderOtsPartList,
    deletePart,
} from "@/controller/order";
import {
    PRODUCTION_ORDER_STATUS,
    getProductionOrderStatusByValue,
    getSopOrderTypeByValue,
    getPstypByValue,
    ORDER_COMPLETE
} from '@/utils/const'
import { getAllPurchaseTypes, formatForSelect } from '@/utils/purchaseTypeCache'
import {
    getFactoryList,
    getUnitList,
    getStorePositionTypeList
} from '@/controller/systemData'
import CommonUserDialog from "@/views/common/common-user-dialog";
// import FilesUpDown from "@/views/common/file-up-down";
import moment from "moment";
export default {
    data() {
        return {
            // FILE_BIZ_TYPE: 15,
            activeName: 'second',
            viewData: {
                visible: false,
                width: "",
            },
            viewFlag: '',
            SOP_ORDER_TYPE: [],
            ORDER_COMPLETE: ORDER_COMPLETE,
            PRODUCTION_ORDER_STATUS: PRODUCTION_ORDER_STATUS,
            getProductionOrderStatusByValue: getProductionOrderStatusByValue,
            getSopOrderTypeByValue: getSopOrderTypeByValue,
            PSTYP_TYPE: getPstypByValue,
            orderPartList: [],
            unitList: [],
            factoryList: [],
            storePositionTypeList: [],
            // addOrUpdateOrderAppartmentVisible: false,
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            searchForm: {
                partCode: ''
            },
            dataForm: {
                id: '',
                orderCode: '',
                orderType: '',
                orderStatus: '',
                supplierName: '',
                supplierCode: '',
                ekorg: '',
                ekotx: '',
                ekgrp: '',
                eknam: '',
                bukrs: '',
                butxt: '',
                bedat: '',
                txz02: '',
                orderComplete: ''
            },
        };
    },
    components: {
        CommonUserDialog,
        // AddOrUpdateOrderAppartment,
        // FilesUpDown  上传附件
    },
    mounted() {
        this.getUnitList()
        this.getFactoryList()
        this.getStorePositionTypeList()
        this.getOrderCompleteByValue()
    },

    methods: {
        // 新增 / 修改 零件表
        // addOrUpdateOrderAppartmentHandle(id) {
        //     this.addOrUpdateOrderAppartmentVisible = true;
        //     this.$nextTick(() => {
        //         this.$refs.addOrUpdateOrderAppartment.init(
        //             id,
        //             this.dataForm.id
        //         );
        //     });
        // },
        getOrderCompleteByValue() {
            return getOrderCompleteByValue(ORDER_COMPLETE);
        },
        // 查询按钮
        queryHandle() {
            this.pageIndex = 1;
            this.getOrderTblPartList();
        },
        getUnitList() {
            getUnitList({
                code: '',
                name: ''
            }).then(data => {
                if (data && data.code === '00') {
                    this.unitList = data.body;
                }
            })
        },
        getUnitName(code) {
            const unit = this.unitList.find(unit => unit.code === code)
            return unit ? unit.name : ''
        },
        // 转换交付数量
        getLfimg(code) {
           return code ? code : '0'
        },
        // 交付完成
        getElikz(code) {
            return code == 'X' ? '完成' : '未完成'
        },
        // 订单状态
        getOrderConfirm(code) {
            if (code == '') {
                code = '0'
            }
            return code == '1' ? '已确认' : '未确认'
        },
        // 删除标志
        getDeleteFlag(code) {
            if (typeof (code) === 'undefined') {
                code = '0'
            }
            if (code == '') {
                code == '0'
            }
            return code == '0' ? '未删除' : '已删除'
        },
        // 工厂
        getFactoryList() {
            getFactoryList({
                factoryCode: "",
                factoryDesc: "",
                address: "",
                post: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.factoryList = data.body;
                }
            });
        },
        getFactoryName(code) {
            const factory = this.factoryList.find(factory => factory.factoryCode === code)
            return factory ? factory.factoryDesc : ''
        },
        // 库位名称
        getStorePositionTypeList() {
            getStorePositionTypeList({
                storeCode: "",
                storeAddress: "",
                storeName: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.storePositionTypeList = data.body;
                }
            });
        },
        getStorePositionName(code) {
            const storePosition = this.storePositionTypeList.find(storePosition => storePosition.storeAddress === code)
            return storePosition ? storePosition.storeName : ''
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getOrderTblPartList();
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.getOrderTblPartList();
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val;
        },
        // 删除零件
        deleteHandleAppartment(id) {
            let ids = id ? [id] :
                this.dataListSelections.map((item) => {
                    return item.id;
                });
            this.$confirm(`确定进行删除操作?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    deletePart(ids)
                        .then((data) => {
                            if (data && data.code === "00") {
                                this.$message({
                                    message: "操作成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.getOrderTblPartList();
                                    },
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                })
                .catch(() => {});
        },
        init(data, id, viewFlag) {
            this.activeName = 'second',
                this.dataForm.id = id || 0;
            this.viewFlag = viewFlag;
            this.orderPartList = [];
            this.viewData.visible = true;
            // 加载采购类型数据
            getAllPurchaseTypes().then(list => {
                this.SOP_ORDER_TYPE = formatForSelect(list)
            });
            this.$nextTick(() => {
                this.$refs["dataForm"].resetFields();
                if (this.dataForm.id) {
                    // 根据id找订单对象
                    getOrderOtsById({}, this.dataForm.id).then((data) => {
                        if (data && data.code === "00") {
                            this.dataForm.id = data.body.id;
                            this.dataForm.orderCode = data.body.orderCode;
                            this.dataForm.orderType = data.body.orderType;
                            this.dataForm.orderStatus = data.body.orderStatus;
                            this.dataForm.supplierName = data.body.supplierName;
                            this.dataForm.supplierCode = data.body.supplierCode;
                            this.dataForm.ekorg = data.body.ekorg;
                            this.dataForm.ekotx = data.body.ekotx;
                            this.dataForm.ekgrp = data.body.ekgrp;
                            this.dataForm.eknam = data.body.eknam;
                            this.dataForm.bukrs = data.body.bukrs;
                            this.dataForm.butxt = data.body.butxt;
                            this.dataForm.bedat = data.body.bedat;
                            this.dataForm.txz02 = data.body.txz02;
                        }
                    });
                    this.getOrderTblPartList();
                    this.pageIndex = 1;
                }
            });
        },
        // 查所有订单零件表
        getOrderTblPartList() {
            getOrderOtsPartList({
                id: this.dataForm.id,
                elikz: this.dataForm.orderComplete,
                partCode: this.searchForm.partCode,
                pageNo: this.pageIndex,
                pageSize: this.pageSize,

            }).then((data) => {
                if (data && data.code === "00") {
                    this.orderPartList = data.body.records;
                    this.totalPage = data.body.total;
                } else {
                    this.orderPartList = [];
                    this.totalPage = 0;
                }
            });
        },
        dateFormat: function (row, column) {
            var date = row[column.property];
            if (date == undefined) {
                return "";
            }
            return moment(date).format("YYYY-MM-DD前");
        },
        // confirm() {
        //     this.dataForm.orderStatus = '2'
        //     this.dataFormSubmit('订单确认成功')
        // },
        // 表单提交
        dataFormSubmit(msg) {
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    let orderParams = {
                        'id': this.dataForm.id || undefined,
                        'orderCode': this.dataForm.orderCode,
                        'orderType': this.dataForm.orderType,
                        'orderStatus': this.dataForm.orderStatus,
                        'supplierName': this.dataForm.supplierName,
                        'supplierCode': this.dataForm.supplierCode,
                        'ekorg': this.dataForm.ekorg,
                        'ekotx': this.dataForm.ekotx,
                        'ekgrp': this.dataForm.ekgrp,
                        'eknam': this.dataForm.eknam,
                        'bukrs': this.dataForm.bukrs,
                        'butxt': this.dataForm.butxt,
                        'bedat': this.dataForm.bedat,
                        'txz02': this.dataForm.txz02,
                        'source': 'SRM',
                    };
                    if (this.dataForm.id) {
                        editOrder(orderParams)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.$message({
                                        message: msg ? msg : '订单更新成功',
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            this.$emit("refreshDataList");
                                        },
                                    });
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    } else {
                        createOrder(orderParams).then((data) => {
                            if (data && data.code === "00") {
                                this.dataForm.id = data.body.id;
                                this.$message({
                                    message: msg ? msg : "订单创建成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        // this.viewData.visible = false;
                                        this.$emit("refreshDataList");
                                    },
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                    }
                }
            });
        },
        // 订单关闭按钮
        // deleteHandle(id) {
        //     console.log(id)
        //     this.$confirm(`确定订单关闭?`, '提示', {
        //         confirmButtonText: '确定',
        //         cancelButtonText: '取消',
        //         type: 'warning'
        //     }).then(() => {
        //         this.dataForm.orderStatus = '3';
        //         editOrder(this.dataForm)
        //             .then((data) => {
        //                 if (data && data.code === "00") {
        //                     this.$message({
        //                         message: '订单关闭成功',
        //                         type: 'success',
        //                         duration: 1500,
        //                         onClose: () => {
        //                             this.$emit("refreshDataList")
        //                         }
        //                     })
        //                 } else {
        //                     this.$message.error(data.msg);
        //                 }
        //             })
        //             .catch((error) => {
        //                 console.log(error);
        //             });
        //     })
        // },
        // selectPurchase() {
        //     // this.$nextTick(() => {
        //     //     this.dataForm.projectManagerName = 'test'
        //     // })
        //     //const _this = this
        //     this.$refs.commonUserDialog.open(USER_TYPE.PERCHASE)
        //     this.$refs.commonUserDialog.onClosed = (payload) => {
        //         if (payload.option === DIALOG_CLOSED_TYPE.CONFIRM) {
        //             // this.dataForm.projectManagerId = payload.data.id
        //             this.dataForm.purchaseContacterName = payload.data.realName
        //         }
        //     };
        // },
        getStyle() {
            return 'width: 110px; text-align: right'
        },
        getStyle2() {
            return 'width: 445.5px;'
        },
    },
};
</script>

<style lang="scss" scoped>
.el-dialog__body {
    .org-dialog-form {
        width: 100%;
    }
}

.linetext {
    white-space: pre-line;
}

.button-danger {
    color: #f56c6c;
}

.mb15 {
    margin-bottom: 15px;
}

.fr {
    float: right;
}

.tab_style {
    min-height: 37vh;
}
</style>
